import axios from "axios";

const GET_CIRCULATION_GAMES = "circulations/circulationGames";

const getCirculationGames = (id) =>
  axios.get(`${GET_CIRCULATION_GAMES}?id=${id}`);

const getExactTicketsCount = (ticketGames = [], circulationId) =>
  axios({
    url: `tickets/exactTicketsCount`,
    method: "POST",
    data: {
      ticketGames: ticketGames.map((game) => ({
        gameId: game.id,
        option1: game.option1,
        optionX: game.optionX,
        option2: game.option2,
      })),
      circulationId,
    },
  });

const createTicket = (body) =>
  axios.post(`voidTickets/createTicketByAgent`, body);

const getTicketById = (id) =>
  axios.get(`tickets/byIdForAgent`, { params: { id } });

export {
  getCirculationGames,
  getExactTicketsCount,
  createTicket,
  getTicketById,
};
